<template>
  <div class="login-form login-signin">
    <div class="text-center mb-10 mb-lg-20">
      <h2 class="font-weight-bold">成为时云用户</h2>
      <p class="text-muted font-weight-bold">请输入您的信息创建账号</p>
    </div>
    <!--begin::Form-->
    <form class="form">
      <div class="form-group py-3 m-0">
        <input
          class="form-control h-auto border-0 px-0 placeholder-dark-75"
          type="text"
          placeholder="您的企业名称"
          autocomplete="off"
        />
      </div>
      <div class="form-group py-3 border-top m-0">
        <input
          class="form-control h-auto border-0 px-0 placeholder-dark-75"
          type="text"
          placeholder="手机号"
          autocomplete="off"
          v-model="mobile"
        />
      </div>
      <div class="form-group py-3 border-top m-0">
        <input
          class="form-control h-auto border-0 px-0 placeholder-dark-75"
          type="email"
          placeholder="邮箱"
          v-model="email"
          autocomplete="off"
        />
      </div>
      <div class="form-group py-3 border-top m-0">
        <input
          class="form-control h-auto border-0 px-0 placeholder-dark-75"
          type="Password"
          placeholder="密码"
          autocomplete="off"
          v-model="password"
        />
      </div>
      <div class="form-group py-3 border-top m-0">
        <input
          class="form-control h-auto border-0 px-0 placeholder-dark-75"
          type="Password"
          placeholder="确认密码"
          autocomplete="off"
          v-model="newPassword"
        />
      </div>
      <div class="form-group py-3 border-top border-bottom m-0">
        <div class="input-group">
          <input
            type="text"
            class="form-control h-auto border-0 px-0 placeholder-dark-75"
            placeholder="验证码"
          />
          <div class="input-group-append">
            <button type="button" class="btn btn-link" @click="eAuthCode">发送</button>
          </div>
        </div>
      </div>
      <div
        class="mt-8 form-group d-flex flex-wrap justify-content-between align-items-center mt-3"
      >
        <div class="checkbox-inline">
          <label class="checkbox checkbox-outline m-0 text-muted">
            <input type="checkbox" name="remember" />
            <span></span>
            我同意
          </label>
          <span class="protocol"
            ><a>时云用户协议</a>、<a>阿里云用户协议</a></span
          >
        </div>
      </div>
      <div class="form-group d-flex flex-wrap flex-center">
        <button
          type="button"
          class="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
        >
          确定
        </button>
        <router-link
          to="/auth/login"
          type="button"
          class="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
        >
          取消
        </router-link>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>
<script>
export default {
  name: "PagesAuthRegister",
  data() {
    return {
      mobile: "",
      password: "",
      newPassword: "",
      authCode: "",
      email: "",
      authSN:""
    };
  },
  mounted() {},
  methods: {
    eRegister() {
      let args = {
        mobile: this.mobile,
        email: this.email,
        type: "Mobile",
        verifyCode: this.authCode,
        verifySN: this.authSN,
        password: this.password,
      };
      this.$$.api
        .post("/kernel/authentication/apis/open/authorization/register", args)
        .then((res) => {
          console.log(res);
        });
    },
    eAuthCode() {
      let args = {
        mobile: this.mobile,
      };
      this.$$.api
        .post(
          "/kernel/authentication/apis/open/authorization/sms/register",
          args
        )
        .then((res) => {
          this.authSN = res.data.sn;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.protocol {
  color: #3699ff;
  cursor: pointer;
}
</style>
